import React, { useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Button, Card, Offcanvas, Form } from 'react-bootstrap';
import transaction from "../../actions/transaction";
import { currencyConverter } from "../../utils";

export default function BalanceDetail() {
   const navigate = useNavigate();
   const { id } = useParams();
   const [mutationData, setMutationData] = useState([]);
   const [amount, setAmount] = useState('');
   const [showConfirm, setShowConfirm] = useState(false);
   const handleCloseConfirm = () => setShowConfirm(false);
   const handleShowConfirm = () => setShowConfirm(true);
   const [confirmPassType, setConfirmPassType] = useState(true);
   const [pass, setPass] = useState('')
   const [loading, setLoading] = useState(true);

  useEffect(() => {
   transaction.actions.get_mutation(id).then((res)=>{
      setLoading(false)
      setMutationData(res?.data)
   });
  },[])

  const onProcess = () => {
   let data = {
      partner_id: id,
      amount: amount,
      password: pass
   }

   transaction.actions.post_withdraw(data).then((res)=>{
      navigate('/home')
   });
  }
  return (
   <div className="bg-gray vh-100">
      <div className="fixed-top header bg-gray">
         <div className="text-center fw-semibold">
            Tarik Saldo
         </div>
         <Button className="btn btn-icon btn-success btn-sm btn-radius btn-nav-back" onClick={() => navigate(-1)}>
               <i className="ph-arrow-left text-light"></i>
         </Button>
      </div>

      <div className="pt-5 mx-4 mt-5 mb-3">
         <div className={"text-secondary ts-sm mb-1 " + (loading ? "skeleton":"")}>Total Saldo Anda di {mutationData?.partner?.name}</div>
         <h3 className={"fw-semibold " + (loading ? "skeleton":"")}>{mutationData?.summary?.total_debit && currencyConverter(Number(mutationData?.summary?.total_debit) - mutationData?.summary?.total_credit)}</h3>
      </div>
      <div className="mx-4 mb-3">
         <div className="text-dark ts-sm mb-1">Masukan jumlah saldo yang ingin ditarik*</div>
         <Form.Control className="me-3" onChange={(e) => setAmount(e.target.value)}/>
         <div className="ts-xs text-danger">
            {amount > (Number(mutationData?.summary?.total_debit) - mutationData?.summary?.total_credit) ?
               'Nominal penarikan melebihi saldo' : null
            }
         </div>
      </div>
      <div className="d-grid gap-2 fixed-bottom p-4">
         <Button 
            className="btn-auth rounded-pill p-3" 
            variant="success" 
            onClick={() => handleShowConfirm()}
            disabled={amount === '' || amount > (Number(mutationData?.summary?.total_debit) - mutationData?.summary?.total_credit)}
         >
            NEXT
         </Button>
      </div>

      <Offcanvas show={showConfirm} onHide={handleCloseConfirm} placement="bottom" className="h-auto">
         <Offcanvas.Header closeButton>
            <Offcanvas.Title>Konfirmasi Penarikan Saldo</Offcanvas.Title>
         </Offcanvas.Header>
         <Offcanvas.Body>
            <div className="d-flex align-items-center justify-content-between mb-4">
               <div className="text-secondary">Jumlah</div>
               <div className="fw-semibold">{currencyConverter(amount)}</div>
            </div>
            <Form.Group className="mb-3" controlId="formBasicPassword">
               <Form.Label className="mb-1">Kata Sandi*</Form.Label>
               <div className="position-relative">
                  <Form.Control type={confirmPassType ? 'password' : 'text'} placeholder="Kata sandi" onChange={(e) => setPass(e.target.value)}/>
                  <Form.Text className="input-icon" onClick={()=>setConfirmPassType(!confirmPassType)}>
                     {confirmPassType ?
                        <i className="ph-eye text-success-bold fw-bold"></i> :
                        <i className="ph-eye-slash text-success-bold fw-bold"></i>
                     }
                  </Form.Text>
               </div>
            </Form.Group>
            <div className="d-flex justify-content-between align-items-center w-100 py-2">
              <Button type="button" className="rounded-pill py-2 me-3 w-50 d-flex align-items-center justify-content-center" variant="success-opacity" onClick={() => getTransaction('all')}>
                Batal
              </Button>
              <Button onClick={() => onProcess()} className="rounded-pill py-2 w-50" variant="success">
                Setuju
              </Button>
          </div>
         </Offcanvas.Body>
      </Offcanvas>
   </div>
  );
}